import { render, staticRenderFns } from "./PageTitleForm.vue?vue&type=template&id=7c08c429"
import script from "./PageTitleForm.vue?vue&type=script&lang=ts"
export * from "./PageTitleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports